import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { APP_LOCALES } from 'locale/locale.config';

import { TRACK_LABELS } from 'lib/tracking';
import { useLocale } from 'lib/localeProvider';

import { mobileOnly, tabletUp } from 'styles/utils';
import { fontSize } from 'styles/theme';

import Shape from 'components/shared/Shape/Shape';

import Container from '../Container/Container';
import Ribbon from '../Ribbon/Ribbon';
import CtaButton from '../CtaButton/CtaButton';
import ButtonNew from '../Button/ButtonNew';
import Heading from '../Heading/Heading';
import ExternalLink from '../ExternalLink/ExternalLink';

const containerContentCss = css`
  text-align: center;

  ${mobileOnly} {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  ${tabletUp} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

const titleCss = css`
  margin-bottom: 40px;

  ${mobileOnly} {
    max-width: 340px;
    font-size: ${fontSize['4xl']};
    margin-right: auto;
    margin-left: auto;
  }
`;

const buttonsWrapperCss = css`
  display: inline-flex;
  justify-content: center;

  ${mobileOnly} {
    flex-direction: column;
    justify-items: center;
  }
`;

const ctaButtonCss = css`
  min-width: 25rem;
`;

const ieBtnCss = css`
  ${mobileOnly} {
    margin-top: 25px;
  }

  ${tabletUp} {
    margin-left: 20px;
  }
`;

function BottomCta({ className }) {
  const { localeCode } = useLocale();
  const ieLocale = localeCode === APP_LOCALES.IE;
  const isNhsFirst = localeCode === APP_LOCALES.NHS_FIRST;

  return (
    <section className={className}>
      <Ribbon slant="top">
        <Container>
          <div css={containerContentCss}>
            <Heading css={titleCss} variant="h2">
              {isNhsFirst
                ? 'Test at home, get treatment in-store'
                : 'Test at home, get treatment at the pharmacy'}
            </Heading>

            <div css={buttonsWrapperCss}>
              {/* CTA button */}
              <div>
                <CtaButton
                  css={ctaButtonCss}
                  trackLabel={TRACK_LABELS.BOTTOM_PAGE}
                />
              </div>

              {/* Boots Ireland */}
              {ieLocale && (
                <div css={ieBtnCss}>
                  <ButtonNew
                    as={ExternalLink}
                    href={process.env.BOOTS_IRELAND_URL}
                    rel="noreferrer noopener"
                    target="_blank"
                    skin="outlined"
                    fullWidth
                  >
                    Order on Boots.ie
                  </ButtonNew>
                </div>
              )}
            </div>
          </div>
        </Container>

        <Shape
          variant="rectangle"
          size="lg"
          color="white"
          zIndex={10}
          right={-140}
          bottom={-125}
          desktop
        />

        <Shape
          color="purple"
          size="md"
          variant="circle"
          zIndex={20}
          right={-80}
          bottom={-80}
          desktop
        />
      </Ribbon>
    </section>
  );
}

BottomCta.propTypes = {
  className: PropTypes.node,
};

export default BottomCta;
